module.exports = __webpack_public_path__ + "img/success_icon2.f197d932.svg";